import { registerWidget } from "$json/lib/form-widgets";
import { grid } from "$json/lib/form-widgets-definitions";
import { identity } from "$json/lib/functional";
import { state } from "$json/lib/store";
import { converter } from "$markdown-it-converter";
import { purifyTTyped } from "$json/lib/escape.js";

function uid() {
  return `id-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
}

import "../../../../plugins/control-filter/control-filter.js";

function actiepunt(rowvalue, saved) {
  let id = uid();

  let imageName = rowvalue[6].value;
  let chapterid = saved.chaptermap[rowvalue[7].value.trim()];
  let accessibleText =
    rowvalue[0].value === "1"
      ? `. Uit uw antwoorden op ${
          rowvalue[1].value
        } blijkt dat er geen actie vereist is`
      : `. Uit uw antwoorden op ${
          rowvalue[1].value
        } blijkt dat er actie nodig is`;
  let rowset = document.createElement("tbody");
  // rowset.setAttribute("ariaLabel", ariaLabel);
  rowset.className = "p-actielijst-grid--rowset";
  const originallySelected = rowvalue[0].value === "0";
  rowset.setAttribute("data-expanded", originallySelected);
  const innerHTML = purifyTTyped`
    <tr class="p-actielijst-grid--toprow">
      <td class="p-actielijst-grid--check ${rowvalue[0].value === "1"}"></td>
      <td class="p-actielijst-grid--title"
        >${rowvalue[1].value}<span class="a-offscreen">${accessibleText}</span></td
      >
      <td class="p-actielijst-grid--btns">
        <button
          type="submit"
          form="bb-q"
          name="gotonode"
          data-groupid="${chapterid}"
          value="${chapterid}"
          class="edit"
          >Wijzig antwoord</button
        >
        <button
          id="${id}"
          type="checkbox"
          aria-expanded=${String(originallySelected)}
          aria-controls="${id}-accordion"
          class="accordion-toggle toggler"
          >Toon of verberg informatie</button
        >
      </td>
    </tr>
    <tr
      class="p-actielijst-grid--additional"
      id="${id}-accordion"
      role="region"
    >
      <td class="p-actielijst-grid--content" colspan="2">
        <div class="p-actielijst--doe-nu bb-text" data-type="label">${converter.render(rowvalue[2].value)}</div>
        <div class="p-actielijst--hoe bb-text">
        ${converter.render(rowvalue[3].value)}
        </div>
        <div class="p-actielijst-grid--content--blocks">
          <div class="waarom">${converter.render(rowvalue[5].value)}</div>
          ${
            rowvalue[4].value.trim() === ""
              ? ""
              : `<div class="cbs">
        ${converter.render(rowvalue[4].value)}
                </div>`
          }
        </div>
      </td>
      <td class="p-actielijst-grid--art"></td>
    </tr>
  `;

  rowset.innerHTML = innerHTML;

  const art = rowset.querySelector(".p-actielijst-grid--art");
  if (art) {
    art.style.setProperty(
      "--bg-url",
      `url('../../rijks-cyberscan/plugins/infographics/live/images/${imageName.trim()}?v=20230117')`
    );
    // Horrific hack
    if ("assetmanagement.svg" === imageName.trim()) {
      art.classList.add(".p-actielijst-grid--art-higher");
    }
  }

  rowset
    .querySelector(".p-actielijst-grid--check")
    .addEventListener("click", e =>
      e.target.parentNode.querySelector("button.edit").click()
    );

  rowset.querySelector(".accordion-toggle").addEventListener("click", e => {
    const selected = e.target.ariaExpanded === "false";
    e.target.setAttribute("aria-expanded", selected);
    e.target.closest("tbody").setAttribute("data-expanded", selected);
  });

  return rowset;
}

var render = function (control, widget, group) {
  const outerbody = document.createElement("tbody");
  let saved = state.has("p-chapters-helper")
    ? state.get("p-chapters-helper")
    : {};

  control.value.forEach(function (row, i) {
    var tbody = actiepunt(row, saved);
    outerbody.append(tbody);
  });
  widget.append(outerbody);
};

registerWidget({
  name: "cyberscan-actielijst",
  tagName: "table",
  attribs: identity,
  render,
  setValue: grid.setValue
});

jQuery(document).on(
  "bb-p:control-filter",
  function (ev, control, group, index, grid, data) {
    if (
      control.controltype === "grid" &&
      control["font-class"] === "actielijst"
    ) {
      control.controltype = "cyberscan-actielijst";
    }
  }
);
